<template>
  <div class="page">
    <div class="con_info" @click="goList">
      <template v-if="address">
        <strong>收货信息</strong>
        <p class="name"><span>{{address.consignee}}</span><span>{{address.phone}}</span></p>
        <p class="address">{{address.province}}{{address.city}}{{address.district}}{{address.address}}</p>
      </template>
      <template v-else>
        <strong>收货信息</strong>
        <p class="name">新增收货信息</p>
      </template>
    </div>
    <div class="goods_info">
      <strong>商品信息</strong>
      <div class="det">
        <div class="pic">
          <img :src="goods.goodsimg" />
        </div>
        <div class="det-info">
          <h4>{{goods.goodsname}}</h4>
          <p></p>
          <section>
            <strong>￥{{goods.price}}</strong>
            <van-stepper v-model="num" />
          </section>
        </div>
      </div>
    </div>
    <div class="more_info">
      <strong>更多服务</strong>
      <div class="form">
        <div class="form-item">
          <div class="label">发票</div>
          <van-radio-group v-model="form.is_invoice" direction="horizontal">
            <van-radio name="0" checked-color="#C90827" icon-size="0.13rem">不开发票</van-radio>
            <van-radio name="1" checked-color="#C90827" icon-size="0.13rem">普通发票</van-radio>
          </van-radio-group>
        </div>
        <template v-if="form.is_invoice == 1">
          <div class="form-item">
            <div class="label">发票抬头</div>
            <van-radio-group v-model="form.type" direction="horizontal">
              <van-radio name="0" checked-color="#C90827" icon-size="0.13rem" @click="chooseFp(0)">个人</van-radio>
              <van-radio name="1" checked-color="#C90827" icon-size="0.13rem" @click="chooseFp(1)">单位</van-radio>
            </van-radio-group>
          </div>
          <template v-if="form.type == 0">
            <div class="form-item">
              <div class="label-s">个人名称</div>
              <input type="text" v-model="invoice0.name" placeholder="请填写个人或您的姓名" />
            </div>
          </template>
          <template v-if="form.type == 1">
            <div class="form-item">
              <div class="label-s">单位名称</div>
              <input type="text" v-model="invoice1.name" placeholder="请填写单位名称全称（必填）" />
            </div>
            <div class="form-item">
              <div class="label-s">纳税人识别号</div>
              <input type="text" v-model="invoice1.code" class="red" placeholder="纳税人识别号（必填）" />
            </div>
            <div class="form-item">
              <div class="label-s">注册地址</div>
              <input type="text" v-model="invoice1.regist_address" placeholder="单位注册地址（选填）" />
            </div>
            <div class="form-item">
              <div class="label-s">注册电话</div>
              <input type="text" v-model="invoice1.mobile" placeholder="注册电话" />
            </div>
            <div class="form-item">
              <div class="label-s">开户银行</div>
              <input type="text" v-model="invoice1.bank" placeholder="开户行（选填）" />
            </div>
            <div class="form-item">
              <div class="label-s">银行账号</div>
              <input type="text" v-model="invoice1.bank_number" placeholder="开户银行账号（选填）" />
            </div>
          </template>
        </template>
      </div>
    </div>

    <div class="rule">
      <p>本商品由第三方商家提供。开票、送货和售后服务均由合作商家承担。</p>
      <p>有关商品相关问题靖联系商家客服<img src="../assets/icon_phone.png" style="width: 0.08rem;margin: 0 0.05rem;" /><span style="color:#C90827;">18661777183</span></p>
      <p>发票会在确认收货5日内通过邮寄方式快递给您。发票接收地址同收货地址。</p>
      <p>*价格免责声明：如遇缺货情况，将给予退款处理，不接受其他方式赔偿</p>
      <p>*如您下单即表示同意上述条款</p>
    </div>
    <div class="tabbar">
      <span>待支付：<strong>￥{{goods.price * num}}</strong></span>
      <p @click="submit">提交订单</p>
    </div>

    <!-- <van-action-sheet v-model="show" :actions="!weixinFlag ? actions1 : actions2" cancel-text="取消" close-on-click-action @select="submit" /> -->
  </div>
</template>
<script>
import PayMixins from "../mixins/paymixins"
export default {
  mixins: [PayMixins],
  created() {
    this.id = this.$route.query.id
    this.getData()
    // var invoice = {
    //   bank: "招商银行",
    //   bank_number: "2147483647",
    //   code: "1234567890",
    //   create_time: "1624521948",
    //   id: "11",
    //   mobile: "18888888888",
    //   name: "测试单位",
    //   order_id: "162",
    //   regist_address: "测试注册地址",
    //   type: "1",
    //   user_id: "622517",
    // }
    // var invoice = false
    // if (invoice.type == 0) {
    //   var { name } = invoice
    //   this.invoice0 = {
    //     name: name
    //   }
    // } else if (invoice.type == 1) {
    //   var { name, code, regist_address, mobile, bank, bank_number } = invoice
    //   this.invoice1 = {
    //     name: name,
    //     code: code,
    //     regist_address: regist_address,
    //     mobile: mobile,
    //     bank: bank,
    //     bank_number: bank_number
    //   }
    // }

  },
  data() {
    return {
      id: '',
      address: {},
      goods: {},
      form: {
        is_invoice: "0"
      },
      num: 1,
      invoice0: {},
      invoice1: {},
    }
  },
  methods: {
    getData() {
      let params = { id: this.id }
      this.common.request({
        url: 'Selement',
        methods: 'post',
        params: params,
        callback: res => {
          if (res.data.errcode == 0) {
            console.log(res.data.data)
            this.goods = res.data.data.goods
            var invoice = res.data.data.invoice
            if (invoice.type == 0) {
              var { name } = invoice
              this.invoice0 = {
                name: name
              }
            } else if (invoice.type == 1) {
              var { name, code, regist_address, mobile, bank, bank_number } = invoice
              this.invoice1 = {
                name: name,
                code: code,
                regist_address: regist_address,
                mobile: mobile,
                bank: bank,
                bank_number: bank_number
              }
            }
            if (this.$route.query.address && this.$route.query.address.id) {
              this.address = this.$route.query.address
            } else {
              this.address = res.data.data.address
            }
          }
        }
      })
    },
    chooseFp(val) {


    },
    submit() {
      if (this.form.is_invoice == 1 && this.form.type == 0) {
        var invoice = this.invoice0
      } else if (this.form.is_invoice == 1 && this.form.type == 1) {
        var invoice = this.invoice1
      }
      console.log('===>', invoice)
      // return
      let { consignee, phone, province, city, district, address } = this.address
      let params = { ...this.form, ...invoice, consignee: consignee, phone: phone, province: province, city: city, district: district, address: address, buy_num: this.num, id: this.id }
      this.common.request({
        url: "Buy",
        methods: "post",
        params: params,
        callback: res => {
          console.log(res.data.data)
          if (res.data.errcode == 0) {
            this.Buy(res.data.data)
          } else {
          }
        }
      })
      // this.$router.push('/pay_result')
    },
    goList() {
      this.$router.push({
        path: '/addressList',
        query: {
          id: this.id,
          address: this.address
        }
      })
    },
  }
}
</script>
<style>
.van-stepper__minus,
.van-stepper__plus {
  width: 0.14rem;
  height: 0.14rem;
  background: none;
}
.van-stepper__input {
  background: none;
  color: #c90827;
}
.van-radio__label {
  font-size: 0.13rem;
}
.van-radio__icon--checked .van-icon-success::before {
  content: "";
  display: block;
  width: 0.06rem;
  height: 0.06rem;
  background: #c90827;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.van-radio__icon--checked .van-icon {
  background-color: #fff !important;
  position: relative;
}
input.red:-ms-input-placeholder {
  color: #c90827;
} /* Internet Explorer 10+ */

input.red::-webkit-input-placeholder {
  color: #c90827;
} /* WebKit browsers */

input.red::-moz-placeholder {
  color: #c90827;
} /* Mozilla Firefox 4 to 18 */

input.red:-moz-placeholder {
  color: #c90827;
}
</style>
<style lang="less" scoped>
.page {
  padding-bottom: 0.6rem;
  .con_info {
    margin: 0 0.1rem;
    padding: 0.1rem 0;
    border-bottom: 0.01rem dashed #ebd28e;
    position: relative;
    background-color: #fff;
    &::before {
      content: "";
      display: block;
      width: 0.09rem;
      height: 0.17rem;
      background: url("../assets/arrow_right.png") no-repeat;
      background-size: 100% auto;
      position: absolute;
      right: 0;
      top: 0.3rem;
    }
    strong {
      font-size: 0.15rem;
      color: #333;
    }
    .name {
      font-size: 0.14rem;
      color: #333;
      margin: 0.1rem 0;
      span {
        &:first-child {
          margin-right: 0.15rem;
        }
      }
    }
    .address {
      font-size: 0.13rem;
      color: #666;
    }
  }
  .goods_info {
    border-top: 0.1rem solid #f4f4f4;
    border-bottom: 0.1rem solid #f4f4f4;
    padding: 0.1rem;
    background-color: #fff;
    & > strong {
      font-size: 0.15rem;
      color: #333;
    }
    .det {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 0.1rem;
      .pic {
        width: 1.05rem;
        height: 1.05rem;
        background: #e5e5e5;
        border-radius: 0.075rem;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      &-info {
        width: calc(100% - 1.2rem);
        h4 {
          font-size: 0.14rem;
          color: #333333;
          line-height: 0.21rem;
          display: -webkit-box;
          word-break: break-all;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; // 需要显示的行数
          overflow: hidden;
          text-overflow: ellipsis;
        }
        & > p {
          font-size: 0.13rem;
          color: #666;
          padding: 0.05rem 0;
        }
        & > section {
          display: flex;
          justify-content: space-between;
          align-items: center;
          strong {
            font-size: 0.19rem;
            color: #c90827;
          }
        }
      }
    }
  }

  .more_info {
    border-top: 0.1rem solid #f4f4f4;
    border-bottom: 0.1rem solid #f4f4f4;
    padding: 0.1rem;
    background-color: #fff;
    & > strong {
      font-size: 0.15rem;
      color: #333;
    }
    .form {
      &-item {
        display: flex;
        align-content: center;
        padding-top: 0.1rem;
        .label {
          width: 8em;
          font-size: 0.13rem;
          color: #666;
          font-weight: bold;
          &-s {
            font-size: 0.13rem;
            color: #666;
            width: 8em;
          }
        }
        input {
          width: calc(100% - 0.8rem);
          font-size: 0.13rem;
          color: #999;
        }
      }
    }
  }
  .rule {
    padding: 0.1rem;
    background-color: #fff;
    p {
      font-size: 0.11rem;
      color: #666;
      margin-bottom: 0.1rem;
      &::before {
        content: "";
        display: inline-block;
        width: 5px;
        height: 5px;
        background: #c90827;
        border-radius: 50%;
        margin-right: 0.05rem;
      }
    }
  }
  .tabbar {
    width: 100%;
    height: 0.55rem;
    background: #ffffff;
    box-shadow: 0px -1px 6px 0px rgba(0, 0, 0, 0.18);
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.1rem;
    span {
      font-size: 0.14rem;
      color: #737373;
      strong {
        font-size: 0.19rem;
        color: #c90827;
      }
    }
    p {
      width: 1.07rem;
      height: 0.4rem;
      background: linear-gradient(270deg, #ddb253, #f0cd7b);
      background-image: url("../assets/btn_bg.png");
      background-size: 100% 100%;
      border-radius: 0.2rem;
      text-align: center;
      line-height: 0.4rem;
      color: #fff;
      font-size: 0.15rem;
    }
  }
}
</style>